import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const TimeIcon = ({ className, color = Color.Gray400 }: NewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.93334 14.9167C6.14445 14.9167 4.63334 14.2917 3.40001 13.0417C2.16668 11.7917 1.55557 10.2722 1.56668 8.48333H3.13334C3.14445 9.82778 3.61112 10.975 4.53334 11.925C5.45557 12.875 6.5889 13.35 7.93334 13.35C9.2889 13.35 10.4445 12.8694 11.4 11.9083C12.3556 10.9472 12.8333 9.78333 12.8333 8.41667C12.8333 7.08333 12.3528 5.95555 11.3917 5.03333C10.4306 4.11111 9.27779 3.65 7.93334 3.65C7.26668 3.65 6.63612 3.78611 6.04168 4.05833C5.44723 4.33055 4.92223 4.7 4.46668 5.16667H5.86668V6.38333H2.05001V2.6H3.23334V4.18333C3.84445 3.52778 4.55279 3.01111 5.35834 2.63333C6.1639 2.25555 7.02223 2.06667 7.93334 2.06667C8.82223 2.06667 9.65834 2.23611 10.4417 2.575C11.225 2.91389 11.9111 3.37222 12.5 3.95C13.0889 4.52778 13.5528 5.20278 13.8917 5.975C14.2306 6.74722 14.4 7.57778 14.4 8.46667C14.4 9.35555 14.2306 10.1917 13.8917 10.975C13.5528 11.7583 13.0889 12.4417 12.5 13.025C11.9111 13.6083 11.225 14.0694 10.4417 14.4083C9.65834 14.7472 8.82223 14.9167 7.93334 14.9167ZM10 11.3167L7.43334 8.78333V5.11667H8.61668V8.26666L10.8667 10.45L10 11.3167Z"
      fill={color}
    />
  </svg>
);
